// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_n2-0";